export const CHANGE_RESULTS = 'Change results';
export const UPDATE_FACETS = 'Update Facets';
export const SET_FACETS = 'Set Facets';
export const FETCHING_FACETS_ERROR = 'Fetching Facets Error';
export const SET_ROOT_ORGANIZATIONS = 'Set Root Organizations';
